// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"color-invert"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 21.1066V3L6.6967 8.3033C3.76777 11.2322 3.76777 15.981 6.6967 18.9099C8.16117 20.3744 10.0806 21.1066 12 21.1066Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 21.1066V3L17.3033 8.3033C20.2322 11.2322 20.2322 15.981 17.3033 18.9099C15.8388 20.3744 13.9194 21.1066 12 21.1066Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 20V4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 21C14.0474 21 15.5 20.5905 17.3033 18.9099M17.3033 18.9099C20.2888 16.1275 20 11 17.3033 8.3033M17.3033 18.9099C20.2322 15.981 20.2322 11.2322 17.3033 8.3033M17.3033 18.9099C14.3744 21.8388 9.62563 21.8388 6.6967 18.9099C3.76777 15.981 3.76777 11.2322 6.6967 8.3033L12 3L17.3033 8.3033","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ColorInvertIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'color-invert',
    ref,
    icon: element,
  },
));

ColorInvertIcon.displayName = 'ColorInvertIcon';

export default ColorInvertIcon;
